<app-card-table
    #personAuthorizationTable
    tableKey="personAuthorizations"
    translatePrefix="person.authorization."
    [tableTitle]="'person.authorization.labelMulti'"
    [items]="items"
    [gridData]="items?.length ? undefined : store.data.getPersonContacts()"
    [columns]="columns"
    [hideCheckboxes]="true"
    [additionalFilter]="additionalFilters()"
    [refreshCallback]="store.api.getPersonContacts"
    [refreshCallbackFragment]="personContactFrag"
    (createCallback)="personAuthorizationsDetail()"
    (detailCallback)="personAuthorizationsDetail($event)"
    (deleteCallbackWithEvent)="deletePersonAuthorization($event)"
    [showDetail]="!!personId() && canEdit()"
    [showDelete]="canEdit()"
    [showCreate]="canEdit()"
>
    <ng-template pTemplate="authorizationType" let-item="item">
        {{ 'person.enum.authorization.' + item.subType | translate }}
    </ng-template>
</app-card-table>
